import styled from 'styled-components';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

const main = {
  height: {
    wxgaPlus: functions.responsive.vw(
      572,
      554,
      breakpoints.wxgaPlus.width,
      breakpoints.fullHd.width
    ),
    fullHd: '554px',
  },
};

export const NewExamImagesGalleryStyle = styled.div`
  background-color: ${colors.black};
  border-radius: 12px;
  height: 64vw;
  min-height: 240px;
  overflow: hidden;
  padding: 20px 0 0;
  position: relative;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    height: 32vw;
  }

  @media (min-width: ${breakpoints.hd.width}px) {
    height: 100%;
    max-height: 862px;
    min-height: initial;
  }

  @media (min-width: ${breakpoints.wxgaPlus.width}px) {
    height: ${main.height.wxgaPlus};
    justify-content: space-between;
    max-height: initial;
  }

  @media (min-width: ${breakpoints.fullHd.width}px) {
    height: ${main.height.fullHd};
  }

  .input-range-container {
    ${zIndex.hills};
    background-color: ${colors.veryDarkGrayishBlue};
    border-radius: 8px;
    margin: 0 auto;
    max-width: 260px;
    padding-bottom: 5px;
    padding: 12px 108px 12px 20px;
    position: relative;
    width: 100%;

    .input-range-element {
      appearance: none;
      -webkit-appearance: none;
      background-color: transparent;
      display: block;
      height: 16px;
      outline: none;
      position: relative;
      width: 100%;

      &::-webkit-slider-thumb {
        appearance: none;
        -webkit-appearance: none;
        background-color: ${colors.white};
        border-radius: 50%;
        cursor: pointer;
        height: 16px;
        position: relative;
        width: 16px;
        ${zIndex.hills};
      }

      &::-moz-range-thumb {
        background-color: ${colors.white};
        border-radius: 50%;
        cursor: pointer;
        height: 16px;
        position: relative;
        width: 16px;
        ${zIndex.hills};
      }

      &:before {
        background-color: ${colors.black};
        content: '';
        display: block;
        height: 4px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
      }
    }

    .input-range-label,
    .input-range-value {
      font-size: 13px;
      line-height: 22px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      padding-bottom: 5px;
    }

    .input-range-label {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.grayishBlue};
      right: 64px;
      width: 28px;
    }

    .input-range-value {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryPaleBlue};
      right: 20px;
      text-align: right;
      width: 36px;
    }
  }

  .exam-images-container {
    display: flex;
    height: 100%;
    left: 0;
    padding: 92px 104px 64px;
    position: absolute;
    top: 0;
    width: 100%;

    .single-exam-image {
      align-items: center;
      display: block;
      display: flex;
      height: calc(100% - 92px - 64px);
      justify-content: center;
      opacity: 0;
      position: absolute;
      width: calc(100% - 104px * 2);

      &.show {
        opacity: 1;
      }

      .exam-image-file {
        display: block;
        height: auto;
        max-height: 100%;
        max-width: 100%;
        width: auto;
      }
    }
  }

  .image-gallery-navigation-previous,
  .image-gallery-navigation-next {
    ${zIndex.hills};
    background-color: ${colors.black};
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    transition: background-color 300ms;
    width: 64px;

    &:not(:disabled) {
      &:hover {
        background-color: ${functions.rgba(colors.white, 0.1)};
      }
    }

    &:disabled {
      svg {
        fill: ${functions.rgba(colors.white, 0.3)};
      }
    }

    svg {
      display: block;
      fill: ${colors.white};
      height: auto;
      margin: 0 auto;
      transition: fill 300ms;
      width: 16px;
    }
  }

  .image-gallery-navigation-previous {
    left: 0;

    svg {
      transform: rotate(90deg);
    }
  }

  .image-gallery-navigation-next {
    right: 0;

    svg {
      transform: rotate(-90deg);
    }
  }

  .show-modal {
    ${zIndex.hills};
    display: block;
    height: 24px;
    position: absolute;
    right: ${24 - (24 - 20) / 2}px;
    top: ${24 - (24 - 20) / 2}px;
    width: 24px;

    svg {
      display: inline-block;
      fill: ${colors.mostlyWhite};
      height: 20px;
      width: 20px;
    }
  }

  .exam-image-modal-container {
    background-color: ${colors.black};
    height: 100vh;
    padding: 40px;
    width: 100%;

    .modal-content {
      background-color: ${colors.black};
      border-radius: 12px;
      height: 100%;
      padding-top: 20px;
      position: relative;
      width: 100%;

      .exam-images-wrapper {
        height: 100%;
        width: 100%;
        overflow: hidden;

        .exam-images-container {
          overflow: hidden;
          .exam-image-wrapper {
            align-items: center;
            display: flex;
            max-width: 50%;
            min-width: 50%;

            &:nth-child(2n + 1) {
              justify-content: flex-end;

              .exam-image-file {
                transform-origin: center right;
              }
            }

            &:nth-child(2n + 2) {
              .exam-image-file {
                transform-origin: center left;
              }
            }

            .exam-image-file {
              display: block;
              height: auto;
              max-height: 100%;
              max-width: 100%;
              width: auto;
            }
          }
        }
      }

      .single-exam-image {
        padding: 0 40px;
      }

      .image-gallery-navigation-previous {
        border-bottom-left-radius: 12px;
        border-top-left-radius: 12px;
      }

      .image-gallery-navigation-next {
        border-bottom-right-radius: 12px;
        border-top-right-radius: 12px;
      }

      .image-gallery-scale-actions {
        ${zIndex.hills};
        background-color: ${colors.veryDarkGrayishBlue};
        border-radius: 12px;
        bottom: 40px;
        height: 60px;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        width: 120px;

        &:after {
          background-color: ${functions.rgba(colors.grayishBlue, 0.7)};
          content: '';
          display: block;
          height: 32px;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 1px;
        }

        .image-gallery-scale-positive,
        .image-gallery-scale-negative {
          height: 100%;
          width: 50%;

          svg {
            fill: ${colors.grayishBlue};
            height: auto;
            width: 16px;
          }
        }
      }
    }
  }

  .no-image-photo{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .loading-section{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.mostlyWhite};
    height: 100%;
    width: 100%;

  }
`;
